export default {
  methods: {
    forTabletPortaitOnly() {
      return window.matchMedia('(min-width: 600px) and (max-width: 899px)').matches
    },
  },
}
